import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { listenAuthState, logout } from './authService';
import { useDispatch } from 'react-redux';
import { setAuthUser, clearAuthUser, setAuthLoading } from '../store/slices/authSlice';

const AuthContext = createContext({ user: null, loading: true });

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    const unsub = listenAuthState(u => {
      setUser(u);
      setLoading(false);
      dispatch(setAuthLoading(false));
      if (u) {
        // UserImpl全体ではなく必要なプロパティのみ渡す
        dispatch(setAuthUser({
          uid: u.uid,
          email: u.email,
          displayName: u.displayName,
          photoURL: u.photoURL
        }));
      } else {
        dispatch(clearAuthUser());
      }
    });
    return () => unsub();
  }, []);

  const refreshUser = useCallback(() => {
    // auth().currentUser は参照同一のためスプレッドで強制再評価
    setUser(prev => {
      if (!window?.firebaseAuthCurrentUser && !prev) return prev; // 形式的
      // firebase の currentUser を再取得できるように import 循環避けで dynamic 参照はせず listenAuthState に任せる
      // ここでは既存 user オブジェクトを shallow copy して再レンダーを強制
      return prev ? { ...prev } : null;
    });
  }, []);

  const value = {
    user,
    loading,
    signOut: logout,
    isAuthenticated: !!user,
    refreshUser,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
